import QRCode from "qrcode";

const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const qrDataUrl = (url, width = 512) => QRCode.toDataURL(url, { width, margin: 4, errorCorrectionLevel: "H", color: { dark: "#17251d", light: "#ffffff" } });

export const downloadQr = async (url, format, filename) => {
  if (format === "svg") {
    const svg = await QRCode.toString(url, { type: "svg", margin: 4, errorCorrectionLevel: "H", width: 1024, color: { dark: "#17251d", light: "#ffffff" } });
    downloadBlob(new Blob([svg], { type: "image/svg+xml;charset=utf-8" }), `${filename}.svg`);
    return;
  }
  const dataUrl = await qrDataUrl(url, 1400);
  const blob = await fetch(dataUrl).then(response => response.blob());
  downloadBlob(blob, `${filename}.png`);
};

export { downloadBlob };
